import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'nm-breadcrumbs',
	templateUrl: './breadcrumbs.html',
	styleUrls: ['./breadcrumbs.css']
})
export class NmBreadcrumbs {

	public routes: string[];

	// Reserve detail keyword for create and edit
	private _parseUrl = (url: string) => {
		let _url = url.split('/');
		if(/^.+\/(edit|view)\/[^\/]+/.test(url)) {
			_url = _url.slice(0,-1);
		}
		return _url.filter(v => !!v);
	}

	public constructor(
		router: Router
	) {
		let routeArr = router.url.split('?');
		this.routes = this._parseUrl(routeArr[0]);

		router.events.subscribe(val => {
			this.routes = this._parseUrl(routeArr[0]);
		});
	}

}


// WEBPACK FOOTER //
// ./src/widgets/breadcrumbs/breadcrumbs.ts